import React from 'react'
import { Button as MUIButton, ButtonProps } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

type Props = ButtonProps & {
  title: string
  isLoading?: boolean
  variant?: string
}

export function Button ({ title, isLoading, variant, ...rest }: Props) {
  return (
    <>
      {isLoading &&
      <LoadingButton loading {...rest}>
        {title}
      </LoadingButton>
      }
      {!isLoading &&
        <MUIButton {...rest} variant={(variant != null) ? variant : 'contained'}>
          {title}
        </MUIButton>
      }
    </>
  )
}
